// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__CJQZG","modal":"Modal_modal__-PVB0","slide-down":"Modal_slide-down__uhYMW","content":"Modal_content__CQMos"};